module.exports = __webpack_public_path__ + "img/dynamic-2.5d4d40dd.png";